import { Link } from "react-router-dom";
import { Sparkles } from "lucide-react";

const HERO = "https://images.unsplash.com/photo-1604177091072-b7b677a077f6?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzOTB8MHwxfHNlYXJjaHwxfHxpbmRpYW4lMjBzdHVkZW50JTIwd29ya2luZyUyMGxhcHRvcCUyMHRlY2glMjBzdHVkeXxlbnwwfHx8fDE3OTE1NTMxMzN8MA&ixlib=rb-4.1.0&q=85";

export default function AuthLayout({ title, subtitle, children, footer }) {
  return (
    <div className="min-h-screen grid lg:grid-cols-2 bg-[#FDFBF7]">
      <div className="flex flex-col justify-center px-6 sm:px-10 lg:px-16 py-12">
        <div className="w-full max-w-md mx-auto">
          <Link to="/" className="flex items-center gap-2 mb-10" data-testid="auth-logo">
            <div className="w-9 h-9 rounded-xl bg-[#7A222B] flex items-center justify-center">
              <Sparkles className="w-5 h-5 text-[#FDF0EC]" />
            </div>
            <span className="font-display text-2xl" style={{ fontWeight: 800 }}>Master</span>
          </Link>
          <h1 className="font-display text-3xl sm:text-4xl font-bold tracking-tight text-[#2D2825]" style={{ fontWeight: 700 }}>
            {title}
          </h1>
          {subtitle && <p className="mt-3 text-[#6E665E]">{subtitle}</p>}
          <div className="mt-8">{children}</div>
          {footer && <div className="mt-6 text-sm text-[#6E665E]">{footer}</div>}
        </div>
      </div>
      <div className="hidden lg:block relative">
        <img src={HERO} alt="Students learning AI" className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-t from-[#2D2825]/80 via-[#2D2825]/30 to-transparent" />
        <div className="absolute bottom-12 left-12 right-12 text-white">
          <p className="font-display text-2xl leading-snug" style={{ fontWeight: 600 }}>
            "Find jobs, internships and projects that put your AI skills to work — and get hired on the strength of what you build."
          </p>
        </div>
      </div>
    </div>
  );
}
